module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/2/6-179a8db89e57690ef983f0b254857804.png";